/**
 * @file CompetitionInfo — placeholder cards describing the current challenge.
 *
 * Values are passed in (mock for now). Later these will be populated from the
 * parsed current.json Competition model; the prop shape below is deliberately
 * close to that model so swapping the data source is trivial.
 */

/**
 * @param {{ label: string, value: string, wide?: boolean }} props
 */
function InfoCard({ label, value, wide = false }) {
  return (
    <div className={`scrw-info-card${wide ? ' scrw-info-card--wide' : ''}`}>
      <p className="scrw-info-card__label">{label}</p>
      <p className="scrw-info-card__value">{value}</p>
    </div>
  );
}

/**
 * @param {{
 *   theme?: string,
 *   title?: string,
 *   description?: string,
 *   generatedAt?: string
 * }} props
 */
export function CompetitionInfo({
  theme = '—',
  title = '—',
  description = '—',
  generatedAt = '—',
}) {
  return (
    <section className="scrw-info" aria-label="Competition information">
      <div className="scrw-info__grid">
        <InfoCard label="Theme" value={theme} />
        <InfoCard label="Title" value={title} />
        <InfoCard label="Generated at" value={generatedAt} />
        <InfoCard label="Description" value={description} wide />
      </div>
    </section>
  );
}
